import { Helmet } from "react-helmet-async";
import { Server, Cpu, Rocket, Users, Shield, Headphones } from "lucide-react";
import TierPageLayout from "@/components/pricing/TierPageLayout";

const EnterpriseTierPage = () => {
  return (
    <>
      <Helmet>
        <title>Enterprise Plan | Custom Solutions for Large Organizations | Upfixe</title>
        <meta name="description" content="Enterprise plan with on-premise hosting, custom AI training, bulk automation, and dedicated support for large organizations." />
        <meta name="keywords" content="enterprise plan, custom solution, on-premise, dedicated support, large scale" />
        <meta property="og:title" content="Enterprise Plan | Custom Solutions for Large Organizations | Upfixe" />
        <meta property="og:description" content="Enterprise plan with on-premise hosting, custom AI training, bulk automation, and dedicated support for large organizations." />
        <link rel="canonical" href="https://upfixe.com/tiers/enterprise" />
      </Helmet>
      <TierPageLayout
      tierName="Enterprise"
      tagline="ENTERPRISE SOLUTIONS"
      headline="Custom Solutions for Large Organizations"
      subheadline="Everything in Agency plus on-premise hosting, custom AI training, bulk automation, and dedicated support tailored to your needs."
      price="Custom"
      priceNote="Contact us for pricing"
      bestFor="Large Organizations"
      audienceDescription="For enterprises requiring custom integrations, dedicated infrastructure, and white-glove support. We build solutions around your specific needs."
      isEnterprise={true}
      features={[
        {
          icon: <Server className="h-5 w-5" />,
          title: "On-Premise Hosting",
          description: "Deploy Upfixe on your own infrastructure for maximum control and security."
        },
        {
          icon: <Cpu className="h-5 w-5" />,
          title: "Custom AI Training",
          description: "Train AI models on your data for industry-specific optimization."
        },
        {
          icon: <Rocket className="h-5 w-5" />,
          title: "Bulk Campaign Automation",
          description: "Launch hundreds of campaigns simultaneously with automated workflows."
        },
        {
          icon: <Users className="h-5 w-5" />,
          title: "Team Functions",
          description: "Role-based access, team collaboration, and approval workflows."
        },
        {
          icon: <Shield className="h-5 w-5" />,
          title: "Auto-Launch with Landing Pages",
          description: "Automatically create and launch campaigns with new landing pages."
        },
        {
          icon: <Headphones className="h-5 w-5" />,
          title: "Dedicated Support & SLA",
          description: "Named account manager, priority support, and guaranteed SLAs."
        }
      ]}
      limits={[
        "Everything in Agency",
        "On-premise hosting options",
        "Custom AI model training",
        "Bulk campaign automation",
        "Auto-launch with landing pages",
        "Team functions & collaboration",
        "Dedicated support & SLA",
        "Custom integrations"
      ]}
      useCases={[
        {
          title: "Large marketing agencies",
          description: "Agencies with 100+ clients needing custom infrastructure and white-glove support."
        },
        {
          title: "Enterprise marketing teams",
          description: "Fortune 500 companies with complex approval workflows and compliance requirements."
        },
        {
          title: "Franchises & multi-location brands",
          description: "Manage campaigns across hundreds of locations with centralized control."
        },
        {
          title: "Marketing technology companies",
          description: "Integrate Upfixe into your existing platform with custom APIs and workflows."
        }
      ]}
      ctaText="Contact Sales"
    />
    </>
  );
};

export default EnterpriseTierPage;